import classNames from 'classnames';
import styles from './Article.module.scss';

const Article = ({
  message = '',
  title = '',
  useTiledHomePageStyle = false,
}) => (
  <article
    className={classNames(styles.baseArticle, {
      [styles.article]: !useTiledHomePageStyle,
      [styles.tiledHomePageArticle]: useTiledHomePageStyle,
    })}
  >
    <h2>{title}</h2>
    <p>{message}</p>
  </article>
);

export default Article;
